import { Parallax } from "react-parallax";

export const MyParallax = ({ image, children }) => (
  <Parallax bgImage={image} strength={500}>
    <div className={`md:h-[400px]`}>{children}</div>
  </Parallax>
);
